Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK_VERSION = '6.16.1';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/core/dist/version.js
// module id = 2935
// module chunks = 39